<template>
    <v-layout wrap>
        <v-flex xs12>
            <v-card class="card--flex-toolbar">
                <v-toolbar flat>
                    <v-toolbar-title class="grey--text">Reporte de donaciones</v-toolbar-title>
                </v-toolbar>
                <v-container grid-list-md style="max-width: initial; padding: 20px;">
                    <v-form>
                        <v-layout
                            wrap
                            justify-start
                            row
                            fill-height
                        >
                            <v-flex
                                xs12
                                md4
                            >
                                <v-dialog
                                    ref="dialog"
                                    v-model="modal_desde"
                                    :return-value.sync="filter.desde"
                                    persistent
                                    full-width
                                    width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="filter.desde"
                                            label="Desde:"
                                            prepend-icon="mdi-calendar-month"
                                            readonly
                                            clearable
                                            @click:clear="filter.hasta = null"
                                            v-on="on"
                                        />
                                    </template>
                                    <v-date-picker
                                        v-model="filter.desde"
                                        locale="es-MX"
                                        scrollable
                                    >
                                        <v-spacer/>
                                        <v-btn
                                            color="grey"
                                            @click="modal_desde = false"
                                        >
                                            Cancelar
                                        </v-btn>
                                        <v-btn
                                            color="primary"
                                            @click="$refs.dialog.save(filter.desde)"
                                        >
                                            Aceptar
                                        </v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </v-flex>
                            <v-flex
                                xs12
                                md4
                            >
                                <v-dialog
                                    ref="dialog2"
                                    v-model="modal_hasta"
                                    :return-value.sync="filter.hasta"
                                    persistent
                                    full-width
                                    width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="filter.hasta"
                                            label="Hasta:"
                                            prepend-icon="mdi-calendar-month"
                                            :disabled="filter.desde === null"
                                            readonly
                                            clearable
                                            v-on="on"
                                        />
                                    </template>
                                    <v-date-picker
                                        v-model="filter.hasta"
                                        :min="filter.desde"
                                        locale="es-MX"
                                        scrollable
                                    >
                                        <v-spacer/>
                                        <v-btn
                                            color="grey"
                                            @click="modal_hasta = false"
                                        >
                                            Cancelar
                                        </v-btn>
                                        <v-btn
                                            color="primary"
                                            @click="$refs.dialog2.save(filter.hasta)"
                                        >
                                            Aceptar
                                        </v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </v-flex>
                            <v-flex xs12 md4>
                                <v-autocomplete
                                    v-model="institucion_select"
                                    :items="items_instituciones"
                                    :loading="is_loading_instituciones"
                                    :search-input.sync="search"
                                    hide-no-data
                                    hide-selected
                                    cache-items
                                    chips
                                    multiple
                                    item-text="nombre"
                                    item-value="id"
                                    label="Institución"
                                    placeholder="Nombre de la institución"
                                    prepend-icon="mdi-database-search"
                                    return-object
                                >
                                    <template v-slot:selection="data">
                                        <v-chip
                                            v-bind="data.attrs"
                                            :input-value="data.selected"
                                            close
                                            @click="data.select"
                                            @click:close="removeSelect(data.item.id)"
                                        >
                                            <v-avatar left v-if="data.item.image_url">
                                                <v-img :src="data.item.image_url"></v-img>
                                            </v-avatar>
                                            {{ data.item.nombre }}
                                        </v-chip>
                                    </template>
                                </v-autocomplete>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-container>

                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                        color="blue darken-1"
                        class="white--text"
                        :loading="loading"
                        :disabled="loading"
                        @click="listar"
                    >
                        Buscar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-flex>

        <v-flex
            grow
            pt-2
        >
            <v-data-table
                :headers="headers"
                :items="donaciones"
                :options.sync="options"
                :sort-by="'created_at'"
                :sort-desc="true"
                class="elevation-1"
                :footer-props="{itemsPerPageOptions : $root.OPTIONS_PER_PAGE_DATATABLE}"
                :loading="loading"
                :server-items-length="donacionesTotal"
                @update:options="listar"
            >
                <template v-slot:item.institucion.image_url="{item}">
                    <v-avatar size="25px">
                        <img
                            v-if="item.institucion.image_url"
                            :src="item.institucion.image_url"
                            alt="avatar"
                        >
                        <span v-else></span>
                    </v-avatar>
                </template>
                <template v-slot:item.monto_donar="{item}">
                    {{$_currency(item.monto_donar)}}
                </template>
                <template v-slot:item.cliente.nombre="{item}">
                    {{item.cliente.nombre +' '+item.cliente.apellido_paterno+' '+item.cliente.apellido_materno}}
                </template>
                <!--<template v-slot:item.actions="{item}">
                    <v-tooltip left>
                        <template v-slot:activator="{on}">
                            <v-icon
                                small
                                v-on="on"
                                class="mr-2"
                                color="light-blue darken-4"
                                @click="editItemId(item.id)"
                            >
                                edit
                            </v-icon>
                        </template>
                        <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip left>
                        <template v-slot:activator="{on}">
                            <v-icon
                                small
                                v-on="on"
                                color="red"
                                @click="deleteItemConfirm(item)"
                            >
                                delete
                            </v-icon>
                        </template>
                        <span>Eliminar</span>
                    </v-tooltip>
                </template>-->
                <template v-slot:body.append>
                    <tr>
                        <td colspan="4" align="right">
                            Total página
                        </td>
                        <td>
                            <b>{{$_currency(totalPorPagina)}}</b>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="4">
                            Total
                        </td>
                        <td>
                            {{$_currency(donacionesMontoTotal)}}
                        </td>
                    </tr>
                </template>
            </v-data-table>
            <!--<v-dialog
                v-model="dialog_delete"
                max-width="600px"
                persistent
            >
                <v-card>
                    <v-card-title>
                        <span class="headline">Eliminar registro</span>
                    </v-card-title>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn
                            color="gray darken-1"
                            @click="dialog_delete = false"
                        >
                            No
                        </v-btn>
                        <v-btn
                            color="red darken-1"
                            class="white&#45;&#45;text"
                            :loading="loading_delete"
                            :disabled="loading_delete"
                            @click="deleteItem"
                        >
                            Si
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>-->
        </v-flex>
    </v-layout>
</template>

<script>
    import axios from 'axios';
    import EventBus from "@/EventBus";

    export default {
        name: "InstitucionesReportePage",
        components: {

        },
        data() {
            return {
                dialog: false,
                dialog_delete: false,
                headers: [
                    {
                        text: '',
                        align: 'center',
                        sortable: false,
                        width: '50px',
                        value: 'institucion.image_url'
                    },
                    {
                        text: 'Institución',
                        align: 'left',
                        sortable: false,
                        value: 'institucion.nombre'
                    },
                    {
                        text: 'Cliente',
                        align: 'left',
                        sortable: false,
                        width: '250px',
                        value: 'cliente.nombre'
                    },
                    {
                        text: 'Fecha',
                        align: 'left',
                        sortable: false,
                        width: '250px',
                        value: 'created_at'
                    },
                    {
                        text: 'Monto',
                        align: 'left',
                        sortable: false,
                        width: '75px',
                        value: 'monto_donar'
                    },
                ],
                donaciones: [],
                donacionesTotal: 0,
                donacionesMontoTotal: 0,
                filter: {
                    institucion_id: [],
                    desde: null,
                    hasta: null,
                },
                loading: false,
                loading_delete: false,
                options: {
                    descending: true,
                    page: 1,
                    itemsPerPage: this.$root.OPTIONS_PER_PAGE_DATATABLE[0],
                    totalItems: 0
                },
                modal_desde: false,
                modal_hasta: false,
                //SELECT
                items_instituciones: [],
                is_loading_instituciones: false,
                institucion_select: [],
                search: '',
            }
        },
        computed: {
            editItem() {
                if (this.itemSelectId) {
                    return this.instituciones.find((item) => item.id === this.itemSelectId)
                } else {
                    return {
                        id: 0,
                        nombre: '',
                        direccion : '',
                        saldo : 0,
                        activo : false,
                    }
                }
            },
            totalPorPagina(){
                let total = 0;
                this.donaciones.map(item => total += parseFloat(item.monto_donar));
                return total.toFixed(2);
            }
        },

        watch: {
            dialog(val) {
                val || this.close()
            },
            search(val) {
                if (this.is_loading_instituciones
                    || (typeof (val) !== 'string'
                        || (typeof (val) === 'string'
                            && val.length < 1))) return;

                this.is_loading_instituciones = true;

                // Lazily load input items
                axios.get('/api/instituciones/list-to-select', {params: {search: val}})
                    .then((res) => {
                        const {data} = res;

                        this.is_loading_instituciones = false;
                        this.items_instituciones = data;
                    })
                    .catch(() => {
                        this.is_loading_instituciones = false;
                        EventBus.$emit('tugarrafon:show-snackbar',{text_content : 'Error durante la petición. Intenta nuevamente'})
                    });
            },
        },

        created() {
            this.initialize()
        },
        mounted() {

        },
        methods: {
            initialize() {
            },
            close() {
                this.dialog = false;
                this.itemSelectId = 0;
            },
            editItemId(itemId) {
                this.itemSelectId = parseInt(itemId);
                this.dialog = true
            },
            listar() {
                this.loading = true;
                let institucion_id = this.institucion_select.map(item => item.id);
                this.filter.institucion_id = institucion_id;
                const {sortBy, sortDesc, page, itemsPerPage} = this.options;
                axios.get('/api/donaciones', {
                    params: {
                        sortBy: sortBy, sortDesc: sortDesc, page: page, rowsPerPage: itemsPerPage, institucion_id : institucion_id,
                        ...this.filter
                    }
                })
                    .then((success) => {
                        this.loading = false;
                        let {data} = success;
                        this.donaciones = data.data;
                        this.options.page = data.current_page;
                        this.donacionesTotal = data.total;
                        this.donacionesMontoTotal = data.total_donar;
                    })
            },
            saveItem() {
                this.dialog = false;
                this.listar();
            },
            removeSelect (id) {
                const index = this.institucion_select.filter(item => item.id !== id);
                this.institucion_select = index;
            },
        }
    }
</script>

<style scoped>

</style>
